export default function ThinkingSteps({ steps }) {
  if (!steps || steps.length === 0) return null;
  return (
    <div className="flex flex-col gap-1 mb-2">
      {steps.map((s, i) => (
        <div key={i} className="text-[11px] text-gray-400 leading-relaxed">
          {s.content}
        </div>
      ))}
    </div>
  );
}